import useScrollWatcher from "../Shared/ScrollWatcher";
import { useTranslation } from "react-i18next";
import "./thank-you.css";
import { Link } from "react-router-dom";

function ThankYouPage() {
  const [tariffsRef, isTariffsVisible] = useScrollWatcher();
  const { t } = useTranslation();
  return (
    <section
      data-watch
      data-watch-threshold="0.15"
      ref={tariffsRef}
      className={isTariffsVisible ? "tariffs _watcher-view" : "tariffs"}
      style={{ paddingBottom: 0 }}
    >
      <div className="tariffs__container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100svh",
          }}
        >
          <div className="tariffs__body">
            <div className="tariffs__item item-tariffs thank-you-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexFlow: "column",
                }}
              >
                <div className="popup__img">
                  <img src="img/tick.svg" alt="tick" />
                </div>
                <div className="popup__title">
                  {t("contactForm.popupTitle")}
                </div>
                <div className="popup__text">{t("contactForm.popupText")}</div>
                <Link
                  to="/"
                  className={"header__btn button"}
                  style={{ marginTop: "20px" }}
                >
                  {t("notFound.text")}
                </Link>
              </div>
              <div className="circle-wrapper">
                <img
                  src="img/promo-robot.png"
                  alt="Картинка"
                  className="robot-image"
                />
                <div className="half-circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ThankYouPage;
